import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { faCheckCircle, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Objectif, Progression } from 'app/shared/models/Progression/progression';
import { DataService } from 'app/shared/services/data/data.service';
import { ProgressionService } from 'app/shared/services/progression/progression.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-my-skills',
  templateUrl: './my-skills.component.html',
  styleUrls: ['./my-skills.component.scss']
})
export class MySkillsComponent extends SubscriptionBaseComponent implements OnInit {

  faCheckCircle = faCheckCircle;
  faChevronLeft = faChevronLeft;

  myProgression: Progression[] = null;
  color: ThemePalette = 'primary';
  tabsActive: boolean;
  baseUrl: string;
  isLoading = false;

  constructor(
    private progressionService: ProgressionService,
    private dataService: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.dataService.showMySkillsTabs.next(false);
    this.initSub();
    this.getProgressionLicence(this.tabsActive);

  }

  // isValid(objectif: Objectif): boolean {
  //   // return objectif.validation ? true : false;
  //   return false;
  // }

  goBack() {
    this.dataService.showMySkills.next(false);
    this.dataService.showMySkillsTabs.next(false);
  }


  public getProgressionLicence(all: boolean): void {
    all ?
      this.dataService.showMySkillsTabs.next(false) :
      this.dataService.showMySkillsTabs.next(true);

    this.myProgression = null;

    this.isLoading = true;

    this.progressionService.getProgressionLicence(all).subscribe(res => {
      this.myProgression = res?.progression;
      this.baseUrl = res?.baseUrl;

      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.showMySkillsTabs.asObservable().subscribe(tab => {
        this.tabsActive = tab;
      })
    );
  }

}
